module.exports = __webpack_public_path__ + "img/dalou_3_2@2x.cc770095.png";